import type { AssistantEventDraft } from '@/state/assistant-store';
import type { NoteInput } from '@/schemas/note';
import type { TaskInput } from '@/schemas/task';

export function toLocalDateTimeInput(value: Date) {
  return new Date(value.getTime() - value.getTimezoneOffset() * 60_000).toISOString().slice(0, 16);
}

export function createNoteDraftValues(draft: Partial<NoteInput>): NoteInput {
  return {
    title: draft.title ?? '',
    content_markdown: draft.content_markdown ?? '',
    is_pinned: draft.is_pinned ?? false,
    company_id: draft.company_id ?? null,
  };
}

export function createTaskDraftValues(draft: Partial<TaskInput>, userId: string): TaskInput {
  return {
    title: draft.title ?? '',
    description: draft.description ?? '',
    status: draft.status ?? 'todo',
    priority: draft.priority ?? 'medium',
    due_date: draft.due_date ?? '',
    company_id: draft.company_id ?? null,
    assignee_id: draft.assignee_id ?? userId,
  };
}

export function createEventDraftValues(
  draft: AssistantEventDraft,
  now = new Date(),
): {
  title: string;
  description: string;
  event_type: AssistantEventDraft['event_type'];
  starts_at: string;
  ends_at: string;
  reminder_at: string;
  company_id: string;
} {
  const startsAt = draft.starts_at ?? toLocalDateTimeInput(now);
  const endsAt = draft.ends_at ?? toLocalDateTimeInput(new Date(new Date(startsAt).getTime() + 60 * 60 * 1000));

  return {
    title: draft.title,
    description: draft.description ?? '',
    event_type: draft.event_type,
    starts_at: startsAt,
    ends_at: endsAt,
    reminder_at: draft.reminder_at ?? '',
    company_id: draft.company_id ?? '',
  };
}
